const ROUTE_META = [
  {
    key: 'dashboard',
    matches: ['/home', '/dashboard'],
    icon: 'el-icon-s-home',
    titleKey: 'nav.dashboard',
    group: 'home',
    aliases: ['/home', '/dashboard']
  },
  {
    key: 'schedule',
    matches: ['/schedule'],
    icon: 'el-icon-date',
    titleKey: 'nav.schedule',
    group: 'home'
  },
  {
    key: 'lead',
    matches: ['/lead', '/leads'],
    icon: 'el-icon-user',
    titleKey: 'nav.leads',
    group: 'sales'
  },
  {
    key: 'customer',
    matches: ['/customer', '/customers'],
    icon: 'el-icon-s-custom',
    titleKey: 'nav.customers',
    group: 'sales'
  },
  {
    key: 'quote',
    matches: ['/quote', '/quotes'],
    icon: 'el-icon-s-order',
    titleKey: 'nav.quotes',
    group: 'sales'
  },
  {
    key: 'contract',
    matches: ['/contract', '/contracts'],
    icon: 'el-icon-document',
    titleKey: 'nav.contracts',
    group: 'sales'
  },
  {
    key: 'changeOrder',
    matches: ['/change-order'],
    icon: 'el-icon-edit-outline',
    titleKey: 'nav.changeOrders',
    group: 'sales'
  },
  {
    key: 'project',
    matches: ['/project', '/projects'],
    icon: 'el-icon-s-management',
    titleKey: 'nav.projects',
    group: 'delivery'
  },
  {
    key: 'product',
    matches: ['/product', '/products'],
    icon: 'el-icon-goods',
    titleKey: 'nav.products',
    group: 'delivery'
  },
  {
    key: 'subcontractor',
    matches: ['/subcontractor', '/subcontractors'],
    icon: 'el-icon-s-cooperation',
    titleKey: 'nav.subcontractors',
    group: 'delivery'
  },
  {
    key: 'finance',
    matches: ['/finance', '/finance/lead-cost', '/invoices', '/invoice', '/payment-plan'],
    icon: 'el-icon-money',
    titleKey: 'nav.finance',
    group: 'finance',
    aliases: ['/invoices']
  },
  {
    key: 'salesAmount',
    matches: ['/sales-amount'],
    icon: 'el-icon-s-data',
    titleKey: 'nav.salesAmount',
    group: 'finance'
  },
  {
    key: 'report',
    matches: ['/report', '/reports'],
    icon: 'el-icon-s-marketing',
    titleKey: 'nav.reports',
    group: 'reports',
    aliases: ['/reports']
  },
  {
    key: 'template',
    matches: ['/system/contract-templates'],
    icon: 'el-icon-document-copy',
    titleKey: 'nav.templates',
    group: 'reports'
  },
  {
    key: 'systemOverview',
    matches: ['/system/overview'],
    icon: 'el-icon-odometer',
    titleKey: 'nav.systemOverview',
    group: 'system'
  },
  {
    key: 'emailConfig',
    matches: ['/system/mail-settings'],
    icon: 'el-icon-message',
    titleKey: 'nav.emailConfig',
    group: 'system'
  },
  {
    key: 'settings',
    matches: ['/system/users', '/system/roles', '/system/menus', '/system'],
    icon: 'el-icon-setting',
    titleKey: 'nav.settings',
    group: 'system'
  }
]

/** 业务导向的分组顺序：首页 → 销售 → 交付 → 财务 → 报表 → 系统 */
export const NAV_GROUP_ORDER = ['home', 'sales', 'delivery', 'finance', 'reports', 'system']

/** 数据库里旧 menuGroup 值 → 新分组 */
const LEGACY_GROUP_MAP = {
  workspace: 'home',
  pipeline: 'sales',
  finance: 'finance',
  insights: 'reports',
  admin: 'system'
}

const GROUP_ICONS = {
  home: 'el-icon-s-home',
  sales: 'el-icon-s-flag',
  delivery: 'el-icon-s-management',
  finance: 'el-icon-coin',
  reports: 'el-icon-data-line',
  system: 'el-icon-setting'
}

export function resolveRouteMeta(path) {
  const target = String(path || '')
  return ROUTE_META.find(item => item.matches.some(prefix => target.startsWith(prefix))) || null
}

export function routeIcon(path, fallback) {
  const meta = resolveRouteMeta(path)
  return (meta && meta.icon) || fallback || 'el-icon-menu'
}

export function routeTitleKey(path) {
  const meta = resolveRouteMeta(path)
  return meta ? meta.titleKey : ''
}

export function routeGroup(path) {
  const meta = resolveRouteMeta(path)
  return meta ? meta.group : 'sales'
}

export function groupIcon(key) {
  return GROUP_ICONS[key] || 'el-icon-menu'
}

export function normalizeMenuGroup(menuGroup, routePath) {
  const fromRoute = routeGroup(routePath)
  if (menuGroup && NAV_GROUP_ORDER.includes(menuGroup)) {
    return menuGroup
  }
  if (menuGroup === 'pipeline') {
    return fromRoute === 'delivery' ? 'delivery' : 'sales'
  }
  if (menuGroup && LEGACY_GROUP_MAP[menuGroup]) {
    return LEGACY_GROUP_MAP[menuGroup]
  }
  return fromRoute
}

export function normalizeRoute(path) {
  const target = String(path || '')
  const meta = resolveRouteMeta(target)
  if (!meta) return target
  const all = [...meta.matches, ...(meta.aliases || [])]
  const sorted = [...new Set(all)].sort((a, b) => b.length - a.length)
  const hit = sorted.find(p => target === p || target.startsWith(p + '/'))
  if (hit) return target
  const canonical = meta.matches[0]
  return target.startsWith(canonical) ? target : canonical
}
